export const marginSpaceForContent = { base: 5, sm: 10, md: "5rem" };
